<template>
  <div class="white_bg">
    <div class="listArea" v-if="showList">
      <div class="title">
        <div class="compareTitle">
          <div>竞品车型</div>
        </div>
        <div class="addCompare" @click="addCompare">
          <span class="addIcon">+</span>
          <span class="addText">新增竞品</span>
        </div>
      </div>
      <div class="filter_result_container">
        <el-table
          empty-text="暂无数据,敬请期待。"
          :data="compareCarData"
          :cell-class-name="'center'"
          :header-row-class-name="'center table_header'"
        >
          <el-table-column
            v-for="attr of thRef"
            :label="attr.name"
            :prop="attr.type"
            :key="attr.type"
          >
            <template #default="scope">
              <template v-if="attr.type == 'model_img'">
                <img class="model_img" :src="scope.row[attr.type]" alt="" />
              </template>
              <template v-else-if="attr.type == 'brand'">
                {{ scope.row[attr.type] + scope.row.model_name }}
              </template>
              <span v-else :class="attr.class">
                {{ scope.row[attr.type] || "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template #default="scope">
              <div
                class="changeModelBtn"
                @click="changeModel(scope.row.id, 'cancelRefresh')"
              >
                <!-- <span class="addPlus">x</span> -->
                <span>取消关注</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          hide-on-single-page
          layout="prev, pager, next"
          :total="compareCount"
          :page-size="comparePageSize"
          v-model:currentPage="compareCurrentPage"
          @current-change="handleComparePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, watch } from "vue";
import {
  getCarFilterConfig,
  getCarLibrary,
  addCompareCar,
  getCompareCarList,
  delCompareCar,
} from "@/api_drive";
import {
  ElTable,
  ElTableColumn,
  ElPagination,
  ElLoading,
  ElMessage,
} from "element-plus";
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// import 'swiper/dist/css/swiper.css'
//   , useRouter
import { useRoute, useRouter } from "vue-router";
export default {
  name: "competing",
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
  },
  watch: {
    $route(to) {
      if (to.name == "competing_drive") {
        this.showList = true;
        // this.showAdd = false;
      }
    },
  },
  setup() {
    const showList = ref(true);
    // const showAdd = ref(false)
    const route = useRoute();
    const router = useRouter();
    console.log(route.query);
    let { not_in_id } = route.query;
    //筛选项
    const filterConditionRef = ref([]);
    // 筛选项选中的数据
    const filterSelectedData = reactive({});
    //tab签th
    const thRef = ref([
      {
        type: "model_img",
        name: "",
      },
      {
        type: "brand",
        name: "车型",
      },
      {
        type: "energy_type_str",
        name: "能源",
      },
      {
        type: "price",
        name: "指导价",
      },
      {
        type: "total_score",
        name: "综合得分",
        class: "orange",
      },
      {
        type: "top",
        name: "综合排名",
        class: "orange",
      },
    ]);
    const compareIds = ref([]);
    const getCarFilterConfigData = () => {
      getCarFilterConfig().then((res) => {
        if (res.code == 200) {
          const { condition } = res.data;
          filterConditionRef.value = condition;
          for (let item of condition) {
            filterSelectedData[item.field] = {
              selectedText: "",
              params: {},
            };
          }
        }
      });
    };
    // 点击筛选项
    const changeFilterSelectedData = (type, data, selectedText) => {
      if (filterSelectedData[type].selectedText == selectedText) {
        return;
      }
      filterSelectedData[type].selectedText = selectedText;
      if (data) {
        filterSelectedData[type].params = data.params;
      } else {
        filterSelectedData[type].params = {};
      }
      currentPage.value = 1;
      count.value = 0;
      getCarData();
    };
    const count = ref(0),
      currentPage = ref(1),
      pageSize = ref(9999),
      carData = ref([]);

    const compareCount = ref(0),
      compareCurrentPage = ref(1),
      comparePageSize = ref(20),
      compareCarData = ref([]);

    // 获取车型列表数据
    const getCarData = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const data = {
        page: currentPage.value,
        rows: pageSize.value,
      };
      if (not_in_id) {
        data.not_in_id = not_in_id;
      }
      //重新请求list
      let params = {};
      for (let key in filterSelectedData) {
        Object.assign(params, filterSelectedData[key].params);
      }

      compareIds.value = [];
      getCompareCarList({ size: 9999 }).then((res) => {
        if (res.data.list) {
          res.data.list.forEach(function (model) {
            compareIds.value.push(parseInt(model.model_id));
          });
          //params['not_in_id'] = compareIds.value.join(',')
          getCarLibrary({
            ...data,
            ...params,
          }).then((res) => {
            if (res.code == 1) {
              count.value = res.data.count;
              const list = res.data.list;
              if (data.first_id && list[0] && list[0].id == data.first_id) {
                list[0].isWarning = true;
              }
              carData.value = list;
            }
            loading && loading.close();
          });
        }
      });
    };
    getCarFilterConfigData();
    getCarData();

    const getCompareCarData = () => {
      getCompareCarList({ size: 9999 }).then((res) => {
        compareCarData.value = res.data.list;
      });
    };
    getCompareCarData();

    // const initGetData = async () => {
    //   await getCarFilterConfigData()
    //   getCarData()
    // }
    // initGetData()
    // 点击页数时
    const handlePageChange = () => {
      getCarData();
    };
    // 返回传参问题
    const changeModel = (model_id, type) => {

      if (type == "add") {
        addCompareCar({ model_id: model_id }).then((res) => {
          compareIds.value.push(model_id);
          if (res.code == 200) {
            getCarData();
            ElMessage.success("添加成功!");
          } else {
            ElMessage.error(res.message || "添加失败!");
          }
        });
      } else {
        delCompareCar({ model_id: model_id }).then((res) => {
          if (res.code == 200) {
            let index = compareIds.value.indexOf(model_id);
            if (index > -1) {
              compareIds.value.splice(index, 1);
            }
            if (type == "cancelRefresh") {
              getCompareCarData();
            }
            ElMessage.success("添加成功!");
          } else {
            ElMessage.error(res.message || "添加失败!");
          }
        });
      }
    };
    const isCompare = (model_id) => {
      return compareIds.value.indexOf(model_id) == -1;
    };
    watch(compareIds.value, (a, b) => {
      console.log(a, b);
    });
    watch(showList, (a, b) => {
      if (b) {
        getCarData();
      }
    });
    // watch(showAdd, (a, b) => {
    //   if (b) {
    //     getCompareCarData();
    //   }
    // })

    const addCompare = () => {
      router.push({
        path: "/drive/competingadd",
      });
    };
    return {
      filterConditionRef,
      filterSelectedData,
      thRef,
      count,
      currentPage,
      pageSize,
      carData,
      changeFilterSelectedData,
      handlePageChange,
      changeModel,
      isCompare,
      // showAdd,
      showList,
      compareCount,
      compareCurrentPage,
      comparePageSize,
      compareCarData,
      addCompare,
    };
  },
};
</script>

<style scoped lang="less">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addCompare {
  cursor: pointer;
  z-index: 1;
  width: 120px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 28px;
  border: 1px solid #ADADAD;
  display: flex;
  justify-content: center;
  align-items: center;
  .addText {
    font-size: 14px;
    color: #36474F;
    line-height: 21px;
  }
  .addIcon {
    width: 21px;
    height: 21px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/add_20230105.svg) no-repeat;
    margin-right: 11px;
  }
}

.blue {
  width: 5px;
  height: 20px;
  background: #46d4f7;
  border-radius: 1px;
  margin-right: 21px;
}
.model_img {
  width: auto;
  height: 55px;
}
.compareTitle {
  height: 31px;
  font-size: 18px;
  font-weight: bold;
  color: #474747;
  line-height: 31px;
  display: flex;
  align-items: center;
}
.orange {
  font-size: 14px;
  // font-weight: bold;
  // color: #e7816e;
  line-height: 19px;
}
.addPlus {
  width: 16px;
  height: 16px;
  line-height: 13px;
  text-align: center;
  border: 1px solid #3f8fff;
  border-radius: 16px;
  margin-right: 5px;
}
.white_bg {
  width: 1090px;
  padding: 26px 53px 63px 53px;
}

.filter_result_container {
  margin-top: 20px;
}
.changeModelBtn {
  cursor: pointer;
  color: #7d95f3;
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
:deep(.el-tabs__nav-wrap::after) {
  display: none;
}
:deep(.el-tabs__item) {
  height: 45px;
  font-size: 15px;
  // &.is-active, &:hover{
  //   font-weight: bold;
  //   color: #00CDFF;
  // }
}
:deep(.el-tabs__active-bar) {
  height: 3px;
  // background: #00CDFF;
  border-radius: 1px;
}
:deep(.center .cell) {
  text-align: center;
  color: #474747;
}
:deep(.table_header th) {
  background: #f5f7f9;
  font-weight: bold;
}
// .#F5F8FF{
//   background: #F5F8FF;
// }
:deep(.el-pagination) {
  margin-top: 40px;
  text-align: center;
  .btn-prev,
  .btn-next {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

</style>